<template>
<div class="chapter">
<div class="inner_page">
<p class="copyt"><a id="page_4"></a><em class="italic">Front Cover Caption:</em> The more modern Pannier Tanks of the 8750 Class were much employed on the line in the final years of service with Ebbw Junction’s 46XX series No. 4679 in charge of the 11.15am Newport to Brecon in the sunshine of 22nd December 1962 seen running over the level crossing and passing the small signal box at Dowlais Top, a week before the closure of the service on the 29th, when there was snow on the ground. <span class="fn-1">(Gerald T. Robinson</span>)</p>
<p class="copy-1"><em class="italic">Back Cover Top Caption:</em> North of Fochriw Ebbw Junction’s 7736 makes a fine shot in the mountainous landscape as it climbs towards Dowlais Top with the 11.15am Newport to Brecon on 31st August 1957. R.O. <span class="fn-1">(R.o.Tuck/Rail Archive Stephenson)</span></p>
<p class="copy-1"><em class="italic">Back Cover Bottom Caption:</em> Bargoed North Junction in the late 1950s/early 1960s as a 2251 Class 0-6-0 arrives with the 2.15pm</p>
<p class="copy-2">Brecon to Newport. <span class="fn-1">(Ken Mumford Presentations)</span></p>
<p class="copy-ct">First published in Great Britain in 2022 by</p>
<p class="copy-c">Pen and Sword Transport</p>
<p class="copy-c">An imprint of</p>
<p class="copy-c">Pen &amp; Sword Books Ltd.</p>
<p class="copy-c">Yorkshire - Philadelphia</p>
<p class="copy-ct">Copyright © John Hodge and Ray Caston, 2022</p>
<p class="copy-ct">ISBN 978 1 39907 076 8</p>
<p class="copy-c">eISBN 978 1 39907 077 5</p>
<p class="copy-c">Mobi ISBN 978 1 39907 077 5</p>
<p class="copy-ct">The right of John Hodge and Ray Caston to be identified as authors of this work has been asserted by them in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copy-ct">A CIP catalogue record for this book is available from the British Library.</p>
<p class="copy-ct">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the Publisher in writing.</p>
<p class="copy-ct">Pen &amp; Sword Books Ltd incorporates the imprints of Pen &amp; Sword Books Archaeology, Atlas, Aviation, Battleground, Discovery, Family History, History, Maritime, Military, Naval, Politics, Railways, Select, Transport, True Crime, Fiction, Frontline Books, Leo Cooper, Praetorian Press, Seaforth Publishing, Wharncliffe and White Owl.</p>
<p class="copy-ct">For a complete list of Pen &amp; Sword titles please contact</p>
<p class="copy-ct">PEN &amp; SWORD BOOKS LIMITED</p>
<p class="copy-c">47 Church Street, Barnsley, South Yorkshire, S70 2AS, England</p>
<p class="copy-c">E-mail: <span class="weblink"><a href="mailto:enquiries@pen-and-sword.co.uk"><span class="underline">enquiries@pen-and-sword.co.uk</span></a></span></p>
<p class="copy-c">Website: <span class="weblink"><a href="http://www.pen-and-sword.co.uk" target="_blank"><span class="underline">www.pen-and-sword.co.uk</span></a></span></p>
<p class="copy-ct">or</p>
<p class="copy-ct">PEN AND SWORD BOOKS</p>
<p class="copy-c">1950 Lawrence Rd, Havertown, PA 19083, USA</p>
<p class="copy-c">E-mail: <span class="weblink"><a href="mailto:Uspen-and-sword@casematepublishers.com"><span class="underline">Uspen-and-sword@casematepublishers.com</span></a></span></p>
<p class="copy-c">Website: <span class="weblink"><a href="http://www.penandswordbooks.com" target="_blank"><span class="underline">www.penandswordbooks.com</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?35090500